import React from "react";
import Hero from "../components/Hero";
import BannerSlider from "../components/BannerSlider";
import PengumumanAgenda from "../components/PengumumanAgenda"; // gabungkan pengumuman + agenda
import Profile from "../components/Profile";
import GuruInfo from "../components/GuruInfo"; // informasi guru
import Fasilitas from "../components/Fasilitas"; // fasilitas sekolah
import Ekstrakurikuler from "../components/Ekstrakurikuler"; // ekstrakurikuler
import KontakSekolah from "../components/KontakSekolah";
import VisitorCounter from "../components/VisitorCounter";
import StatistikSekolah from "../components/StatistikSekolah";

export default function Home() {
  return (
    <>
      {/* Hero / Banner Utama */}
      <Hero />
    

      {/* Slider / Banner */}
      <BannerSlider />

      {/* Pengumuman & Agenda Sekolah */}
      <PengumumanAgenda />

      {/* Profil Sekolah */}
      <Profile />
      <StatistikSekolah />
      {/* Informasi Guru */}
      <GuruInfo />

{/* Fasilitas Sekolah */}
<Fasilitas />

      {/* Ekstrakurikuler */}
      <Ekstrakurikuler />


          {/* Kontak Sekolah */}
          <KontakSekolah />
          
          <VisitorCounter />
    </>

  );
}
